import { render, staticRenderFns } from "./EditContentAction.vue?vue&type=template&id=40d845d6"
import script from "./EditContentAction.vue?vue&type=script&lang=js"
export * from "./EditContentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports